import {
  APIUser,
  APIUserOrganization,
  APIUserRight,
  APIUserType,
} from 'types/api';

export const TOUR_RIGHTS = [
  APIUserRight.BankAccess,
  APIUserRight.PaymentProcessing,
  APIUserRight.PayeeDirectory,
  APIUserRight.MemberAdministration,
];

const isOrganizationAdmin = (userType: APIUserType) =>
  userType === APIUserType.Admin || userType === APIUserType.SuperAdmin;

const getOrganizationTourRights = ({
  userType,
  userRights,
}: APIUserOrganization): APIUserRight[] => {
  if (isOrganizationAdmin(userType)) {
    return TOUR_RIGHTS;
  }
  const rights = new Set((userRights ?? []).map(it => it.right));
  return TOUR_RIGHTS.filter(it => rights.has(it));
};

export const findTourOrganization = (
  user: APIUser,
): APIUserOrganization | undefined => {
  let best: APIUserOrganization | undefined;
  let bestCount = 0;
  for (const org of user.userOrganizations ?? []) {
    const count = getOrganizationTourRights(org).length;
    if (count > bestCount) {
      best = org;
      bestCount = count;
    }
  }
  return best;
};

export const getTourRights = (
  user: APIUser | null | undefined,
): Set<APIUserRight> => {
  if (!user) {
    return new Set();
  }
  if (user.userType === APIUserType.SuperAdmin) {
    return new Set(TOUR_RIGHTS);
  }
  const org = findTourOrganization(user);
  return new Set(org ? getOrganizationTourRights(org) : []);
};

export const canStartTour = (user: APIUser | null | undefined): boolean =>
  getTourRights(user).size > 0;

export const filterTourSteps = <T extends { userRight?: APIUserRight }>(
  steps: T[],
  user: APIUser | null | undefined,
): T[] => {
  const rights = getTourRights(user);
  return steps.filter(it => !it.userRight || rights.has(it.userRight));
};
